import React, { Component } from 'react';
import {connect} from 'react-redux';
import { FormControl, Checkbox, Radio, DropdownButton, MenuItem } from 'react-bootstrap';
import './Leads.css';
import { API_URL, API_V2_URL, config } from '../../util/Constants';
import axios from 'axios';
import { submitImages } from '../../actions/PhotowallActions';
import MarketingButtons from './MarketingButtons';

class Leads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: {},
      errors: {},
      charLength: 'Characters Left: 140/140',
      hashData: {},
      file: null,
      submitLoad: true,
      submitSpin: false,
      successMsg: '',
      responseError: '',
      others: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleOptinChange = this.handleOptinChange.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.submitUploadForm = this.submitUploadForm.bind(this);
    this.handleClickOptinOtherOptionSingle = this.handleClickOptinOtherOptionSingle.bind(this);
    this.handleSelectOptinOtherOptionSingle = this.handleSelectOptinOtherOptionSingle.bind(this);
    this.handleSelectOptinOtherOption = this.handleSelectOptinOtherOption.bind(this);
    this.handleChangeOptinOther = this.handleChangeOptinOther.bind(this);
  }

  handleChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    if (e.target.type === 'checkbox') {
      fields['terms_conditions'] = e.target.checked ? '1' : '0';
    }
    this.setState({
      fields
    });
  }

  handleOptinChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    if (e.target.type === 'checkbox') {
      fields['marketing'] = e.target.checked ? '1' : '0';
    }
    this.setState({
      fields
    });
  }

  handleSelectOptinOtherOptionSingle = (idOptinOther, e) => {
      const optin = {
          ...this.state
      };
      if (!optin.others[idOptinOther]) {
          optin.others[idOptinOther] = {};
          optin.others[idOptinOther].selectedValues = [];
      }
      optin.others[idOptinOther].selectedValues = [e.target.value];
      this.setState({optin});
  }

  handleClickOptinOtherOptionSingle = (idOptinOther, ooo, e) => {
    const optin = {
        ...this.state
    };
    if (!optin.others[idOptinOther]) {
        optin.others[idOptinOther] = {};
        optin.others[idOptinOther].selectedValues = [];
    }
    optin.others[idOptinOther].selectedValues = [ooo.id];
    this.setState({optin});
  }

  handleSelectOptinOtherOption = (idOptinOther, ooo, e) => {
      const optin = {
          ...this.state
      };
      if (!optin.others[idOptinOther]) {
          optin.others[idOptinOther] = {};
          optin.others[idOptinOther].selectedValues = [];
      }
      if (e.target.checked) {
          optin.others[idOptinOther].selectedValues.push(ooo.id);
      } else {
          optin.others[idOptinOther].selectedValues = optin.others[idOptinOther]
              .selectedValues.filter(o2 => o2 !== ooo.id);
      }
      this.setState({optin});
  }

  handleChangeOptinOther = (idOptinOther, e) => {
      const optin = {
          ...this.state
      };
      if (!optin.others[idOptinOther]) {
          optin.others[idOptinOther] = {};
      }
      optin.others[idOptinOther].value = e.target.value;
      this.setState({optin});
  }

  handleTextAreaChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

    var maxLength = 140;
    if (e.target.value.length > maxLength) {
      this.state.charLength =
        'Characters Left: ' + e.target.value.substring(0, maxLength) + '/140';
    } else {
      this.state.charLength =
        'Characters Left: ' + (maxLength - e.target.value.length) + '/140';
    }
  }

  submitUploadForm(e) {
    e.preventDefault();
    if (this.validateForm()) {
      this.saveUploadDetails();
    }
  }

  saveUploadDetails() {
    // this.state.fields['image'] = result.split(',')[1];
    let formData = this.state.fields;
    // formData.imageName = imageName;
    // this.state.fields = {};

    const { others } = this.state;
    const { competition } = this.props;
    const { currentRound, data } = competition;
    if(data.otherOptins && data.otherOptins.length > 0) {
      const otherData = data.otherOptins
      .filter(o => !o.deleted).map(oo => {
          if (!oo.deleted) {
              if (oo.type === 'text') {
                  return {
                      id: oo.id,
                      type: oo.type,
                      value: others[oo.id] ? others[oo.id].value : ''
                  };
              } else if (oo.type === 'checkbox' || oo.type === 'dropdown' || oo.type === 'radio') {
                  return {
                      id: oo.id,
                      type: oo.type,
                      values: others[oo.id] ? others[oo.id].selectedValues : []
                  };
              }
          }
      });
      formData.other = otherData;
    } else {
      delete formData.other;
      console.log("No optional fields", formData)
    }
    formData.competition_id = data.id;
    this.props.dispatch(submitImages(
      formData,
      this.props.dispatch
    ))
    // .then(response => {
    //   debugger;
      const resetData = {
        // submitSpin: false,
        // submitLoad: true
      };
      let fields = {};
      fields['first_name'] = '';
      fields['last_name'] = '';
      fields['email'] = '';
      fields['terms_conditions'] = '0';
      fields['phone'] = '';
      fields['address'] = '';
      fields['postcode'] = '';
      fields['state'] = '';
      resetData.fields = fields;
      resetData.others = [];
      var otherRadio = document.getElementsByClassName('othersRadio');
      var otherCheckbox = document.getElementsByClassName('othersCheckbox');
      if(data.optinMarketing) {
        document.getElementsByName('marketing')[0].checked = false;
      }
      if(data.optinTncs) {
        document.getElementsByName('terms_conditions')[0].checked = false;
      }
      if(data.otherOptins && data.otherOptins.length > 0) {
        Object.keys(data.otherOptins).forEach(function(key) {
          if (data.otherOptins[key].type == 'dropdown' && data.otherOptins[key].deleted != '1') {
            document.getElementsByClassName('othersDropdown')[0].selectedIndex = false;
          }
        });
      }
      if(otherCheckbox) {
        for (var i = 0; i < otherCheckbox.length; i++) {
          if (otherCheckbox[i].type == 'checkbox')
              otherCheckbox[i].checked = false;
        }
      }
      if(otherRadio) {
        for (var i = 0; i < otherRadio.length; i++) {
          if (otherRadio[i].type == 'radio')
              otherRadio[i].checked = false;
        }
      }
      resetData.charLength = 'Characters Left: 140/140';
      this.setState(resetData);
    // });
  }

  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    const { comp } = this.props;

    if (comp.optinFirstname && !fields['first_name']) {
      formIsValid = false;
      errors['first_name'] = '*Please enter your first name.';
    }

    if (comp.optinLastname && !fields['last_name']) {
      formIsValid = false;
      errors['last_name'] = '*Please enter your last name.';
    }

    if (comp.optinEmail && !fields['email']) {
      formIsValid = false;
      errors['email'] = '*Please enter your email Id.';
    }

    if (typeof fields['email'] !== 'undefined') {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(fields['email'])) {
        formIsValid = false;
        errors['email'] = '*Please enter valid email Id.';
      }
    }

    if (comp.optinTncs && !fields['terms_conditions']) {
      formIsValid = false;
      errors['terms_conditions'] = '*Please select ' + comp.optinTncsCopy;
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  handleTwitterShare = twitterShare => {
    window.open(
      'http://www.twitter.com/intent/tweet?url=' +
        encodeURIComponent(twitterShare.url) +
        '&text=' +
        encodeURIComponent(twitterShare.copy),
      'twitter-share-dialog',
      'width=626,height=436'
    );
  };

  handleFacebookShare = facebookShare => {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(facebookShare.url),
      'facebook-share-dialog',
      'width=626,height=436'
    );
  };

  render() {
    if (this.state.successMsg) {
      setTimeout(
        function() {
          this.state.successMsg = '';
        }.bind(this),
        5000
      );
    }
    if (this.state.responseError) {
      setTimeout(
        function() {
          this.state.responseError = '';
        }.bind(this),
        5000
      );
    }

    const { competition } = this.props;
    const { data, enabledSocialNetworks } = competition;
    let submitSpin = this.state.submitSpin;
    let submitLoad = this.state.submitLoad;
    let successMsg = '';
    if(competition.createImageStatus) {
      submitSpin = false;
      submitLoad = true;
      successMsg = 'Form submitted succesfully';
    }

    const { others } = this.state;

    if (data) {
      let voteCont = (
        <div className='vote-cont'>
          <div className='loading-rounds' />
        </div>
      );
      const facebookShare =
        enabledSocialNetworks &&
        enabledSocialNetworks.find(sn => sn.name === 'Facebook');
      const twitterShare =
        enabledSocialNetworks &&
        enabledSocialNetworks.find(sn => sn.name === 'Twitter');

      voteCont = (
        <div>
          <div className='logos-cont'>
            {data.logoBg && <img src={data.logoBg.file} className='pl-logo img-fluid' />}
            {data.sponsorsBg && data.sponsorsTop == 1 && (
              <img src={data.sponsorsBg.file} className='sp-logo' />
            )}
          </div>
          <div
            style={{
              color: data ? data.primaryColor : ''
            }}
            className='vote-cont'
          >
            <h1 dangerouslySetInnerHTML={{ __html: data.name }} />
            <p
              dangerouslySetInnerHTML={{
                __html: data.description
              }}
              className={'site-description'}
            />
            {data && (
              <form
                method='post'
                name='leadForm'
                onSubmit={this.submitUploadForm}
              >
                <div className='upload-form'>
                  {data.optinFirstname == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='First Name'
                          onChange={this.handleChange}
                          name='first_name'
                          value={this.state.fields.first_name || ''}
                        />
                      </div>
                      <div className='errorMsg'>
                        {this.state.errors.first_name}
                      </div>
                    </div>
                  )}
                  {data.optinLastname == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='Last Name'
                          onChange={this.handleChange}
                          name='last_name'
                          value={this.state.fields.last_name || ''}
                        />
                      </div>
                      <div className='errorMsg'>
                        {this.state.errors.last_name}
                      </div>
                    </div>
                  )}
                  {data.optinPhone == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='Phone'
                          onChange={this.handleChange}
                          name='phone'
                          value={this.state.fields.phone || ''}
                        />
                      </div>
                      <div className='errorMsg'>{this.state.errors.phone}</div>
                    </div>
                  )}
                  {data.optinEmail == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='Email'
                          onChange={this.handleChange}
                          name='email'
                          value={this.state.fields.email || ''}
                        />
                      </div>
                      <div className='errorMsg'>{this.state.errors.email}</div>
                    </div>
                  )}
                  {data.optinAddress == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          componentClass='textarea'
                          placeholder='Address'
                          style={{ height: 120 }}
                          onChange={this.handleTextAreaChange}
                          name='address'
                          value={this.state.fields.address || ''}
                        />
                      </div>
                      <div className='errorMsg'>
                        {this.state.errors.address}
                      </div>
                    </div>
                  )}
                  {data.optinPostcode == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='Postcode'
                          onChange={this.handleChange}
                          name='postcode'
                          value={this.state.fields.postcode || ''}
                        />
                      </div>
                      <div className='errorMsg'>
                        {this.state.errors.postcode}
                      </div>
                    </div>
                  )}
                  {data.optinState == 1 && (
                    <div className='optin-row'>
                      <div className='optin-col'>
                        <FormControl
                          type='text'
                          placeholder='State'
                          onChange={this.handleChange}
                          name='state'
                          value={this.state.fields.state || ''}
                        />
                      </div>
                      <div className='errorMsg'>{this.state.errors.state}</div>
                    </div>
                  )}
                  {data.otherOptins && data.otherOptins.length > 0 ?
                  data.otherOptins.filter(o => !o.deleted).map((oo, otherIndex) => {
                      switch (oo.type) {
                          case 'text':
                              return <div className="optin-row" key={otherIndex}>
                                  <div className='optin-col'>
                                      <FormControl
                                          type="text"
                                          value={(others[oo.id] && others[oo.id].value) || ''}
                                          placeholder={oo.copy}
                                          onFocus={this.sendParentScrollMessage}
                                          onChange={(e) => this.handleChangeOptinOther(oo.id, e)}
                                      />
                                  </div>
                              </div>;
                          case 'checkbox':
                              return <div className="optin-row custom-fld pull-left" key={otherIndex}>
                                  <label className="pull-left">{oo.copy} </label>
                                  {oo.options.filter(o => !o.deleted).map((ooo, index) =>
                                    <div class="custom-control custom-checkbox">
                                      <input type="checkbox" class="custom-control-input" id={index} onClick={(e) => this.handleSelectOptinOtherOption(oo.id, ooo, e)} />
                                      <label class="custom-control-label" for={index} dangerouslySetInnerHTML={{__html: ooo.copy}}/>
                                    </div> 
                                    // <label className="checkbox-inline pull-left" key={index}>
                                    //   <input type="checkbox" className="othersCheckbox" onClick={(e) => this.handleSelectOptinOtherOption(oo.id, ooo, e)} /><span dangerouslySetInnerHTML={{__html: ooo.copy}}/>
                                    // </label>
                                  )}
                              </div>;
                          case 'dropdown':
                              return <div className="optin-row custom-fld pull-left" key={otherIndex}>
                                  <label className="pull-left">{oo.copy} </label>
                                  <select className="othersDropdown pull-left" onChange={(e) => this.handleSelectOptinOtherOptionSingle(oo.id, e)}>
                                    <option></option>
                                    {oo.options.filter(o => !o.deleted).map((ooo, index) =>
                                      <option value={ooo.id} key={index}>{ooo.copy}</option>
                                    )}
                                  </select>
                              </div>;
                          case 'radio':
                              return <div className="optin-row custom-fld pull-left" key={otherIndex}>
                                  <label className="pull-left">{oo.copy} </label>
                                  {oo.options.filter(o => !o.deleted).map((ooo, index) =>
                                    <label className="radio-inline pull-left" key={index}>
                                      <input type="radio" className="othersRadio" name={`radioGroup${oo.id}`} onClick={(e) => this.handleClickOptinOtherOptionSingle(oo.id, ooo, e)} /> <span dangerouslySetInnerHTML={{__html: ooo.copy}}/>
                                    </label>
                                  )}
                              </div>;
                      }
                  }) : null}
                  {data.optinMarketing == 1 && (
                    <div className="optin-row custom-fld pull-left">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input type="checkbox" class="custom-control-input" id="optinMarketingCopy" onChange={this.handleOptinChange}
                            name='marketing'
                            value='1' />
                          <label class="custom-control-label" for="optinMarketingCopy">{data.optinMarketingCopy}</label>
                        </div> 
                        {/* <label className="checkbox-inline pull-left">
                          <input
                            type="checkbox"
                            onChange={this.handleOptinChange}
                            name='marketing'
                            value='1'
                          />{data.optinMarketingCopy}
                        </label> */}
                        <div className='errorMsg'>
                          {this.state.errors.marketing}
                        </div>
                    </div>
                  )}
                  {data.optinTncs == 1 && (
                    <div className="optin-row custom-fld pull-left">
                      <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="optinTncsCopy" onChange={this.handleOptinChange}
                          name='terms_conditions' />
                        <label class="custom-control-label" for="optinTncsCopy">{data.optinTncsCopy}</label>
                      </div> 
                      {/* <label className="checkbox-inline pull-left">
                        <input
                          type="checkbox"
                          onChange={this.handleChange}
                          name='terms_conditions'
                        />{data.optinTncsCopy}
                      </label> */}
                      <div className='errorMsg custom-fld pull-left'>
                        {this.state.errors.terms_conditions}
                      </div>
                    </div>
                  )}
                  <div className='optin-row'>
                    {submitLoad && (
                      <div className='optin-col upload-btn-wrapper'>
                        <input
                          type='submit'
                          className='button submit-btn'
                          value={data.submitCopy}
                        />
                      </div>
                    )}
                    {submitSpin && (
                      <div className='optin-col upload-btn-wrapper'>
                        <i className='fa fa-spinner fa-spin fa-3x' />
                      </div>
                    )}
                    {successMsg && (
                      <div className='successMsg'>{successMsg}</div>
                    )}
                    {facebookShare || twitterShare ? (
                      <div className='shares-cont'>
                        {facebookShare ? (
                          <div
                            className='share-btn faceShare'
                            onClick={() =>
                              this.handleFacebookShare(facebookShare)
                            }
                          >
                            <i
                              className='fa fa-2x fa-facebook'
                              aria-hidden='true'
                            />
                            <div>Share</div>
                          </div>
                        ) : null}
                        {twitterShare ? (
                          <div
                            className='share-btn twitterShare'
                            onClick={() =>
                              this.handleTwitterShare(twitterShare)
                            }
                          >
                            <i
                              className='fa fa-2x fa-twitter'
                              aria-hidden='true'
                            />
                            <div>Share</div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {this.state.responseError && (
                      <div className='errMsg'>{this.state.responseError}</div>
                    )}
                    <div className="tester"></div>
                    <MarketingButtons></MarketingButtons>
                  </div>
                </div>
              </form>
            )}
          </div>
          <div className='logos-cont'>
            {data.sponsorsBg && data.sponsorsTop == 0 && (
              <img src={data.sponsorsBg.file} className='sp-logo' />
            )}
          </div>
          <div className='footer'>
            {data.tncs || data.privacypolicy ? (
              <div className={'floatingFooter'}>
                {data.tncs ? (
                  <a href={data.tncs} target='_blank'>
                    Terms and Conditions
                  </a>
                ) : null}
                {data.tncs && data.privacypolicy ? ' - ' : null}
                {data.privacypolicy ? (
                  <a href={data.privacypolicy} target='_blank'>
                    Privacy Policy
                  </a>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      );

      return <div className={'parent-vote-cont'}>{voteCont}</div>;
    } else {
      return (
        <div className='vote-cont'>
          <div className='loading-rounds' />
        </div>
      );
    }
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {
  const prj = state.default;
  return {
    ...ownProps,
    competition: prj.competition,
    comp: prj.competition.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Leads);



// WEBPACK FOOTER //
// ./src/views/components/Leads.js